import { render, staticRenderFns } from "./Userposts.vue?vue&type=template&id=689078ac&"
import script from "./Userposts.vue?vue&type=script&lang=js&"
export * from "./Userposts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "Userposts.vue"
export default component.exports